import designItem from './DesignInput.vue'
const DesignInput = {
  install: function (Vue) {
    Vue.component('DesignInput', designItem)
  }
}
export default DesignInput
